import { TOOLTIP_MESSAGES } from 'components/KiloTooltip';
import { AthletePackageRetrieve } from 'types';

/** Why Pause Package is unavailable for an athlete package, or null when it can be paused. */
export const getPauseUnavailableReason = (
  athletePackage: Pick<AthletePackageRetrieve, 'status' | 'package' | 'cancellationDate'>,
): string | null => {
  if (athletePackage.status === 'CANCELLED') return TOOLTIP_MESSAGES.PAUSE_CANCELLED;
  if (athletePackage.package.type === 'CREDIT_BASED') return TOOLTIP_MESSAGES.PAUSE_CREDIT_BASED;
  if (athletePackage.cancellationDate) return TOOLTIP_MESSAGES.PAUSE_SCHEDULED_CANCELLATION;
  return null;
};
